import { CircularProgress } from "@mui/material";
import { useRouter } from "next/router";
import { MDXRemote } from "next-mdx-remote";
import { useCallback, useEffect, useState } from "react";
import { convertMDX } from "utils/mdx";

import Breadcrumb from "@/components/brandRefresh/common/Breadcrumb";
import {
  CustomSelectRefresh,
  CustomOptionRefresh,
} from "@/components/onboardingSections/inputs";
import styles from "@/styles/fx.module.scss";

const Fx = ({ data }) => {
  const router = useRouter();
  const [currency, setCurrency] = useState("AUD");
  const [title, setTitle] = useState(null);
  const [description, setDescription] = useState(null);
  const [rate, setRate] = useState([]);
  const [loading, setLoading] = useState(true);
  const dateOptions = { year: "numeric", month: "long", day: "numeric" };

  const setMDX = useCallback(async (source, title) => {
    const mdxSource = await convertMDX(source, false);
    if (title) setTitle(mdxSource);
    else setDescription(mdxSource);
  }, []);

  const getRate = useCallback(
    async selectedCurrency => {
      setLoading(true);
      setCurrency(selectedCurrency);
      try {
        const fxresponse = await fetch(`/api/fx`, {
          method: "POST",
          body: JSON.stringify({
            type: "CREDIT_CARD",
            transactionAmount: 1,
            transactionCurrency: selectedCurrency,
          }),
        });
        const fxres =
          fxresponse.status === 500 ? false : await fxresponse.json();
        setRate(fxres.data[1]);
        setLoading(false);
      } catch {
        router.push("/500");
      }
    },
    [router],
  );

  useEffect(() => {
    getRate("AUD");
    setMDX(data.title.replace("<br>", " "), true);
    setMDX(data.description.replace("<br>", " "));
  }, []);

  return (
    <>
      <div className="pb-[52px] lg:pb-[72px]">
        <Breadcrumb />
      </div>
      <div className="flex flex-col lg:gap-[72px] gap-[52px]">
        <div>
          {title && (
            <div className="text-base 4xl:text-xl">
              <MDXRemote {...title} />
            </div>
          )}
        </div>
        <div className="flex flex-col gap-2.5">
          <h5 className="text-onmoText text-2xl font-medium">
            Pick a currency
          </h5>
          <label htmlFor="currencyOptions" className="text-base 4xl:text-xl">
            Choose a currency from the options listed below:
          </label>
          <div className="relative lg:w-[328px]">
            <CustomSelectRefresh
              id="currencyOptions"
              value={currency}
              onChange={(_, val) => {
                getRate(val);
              }}
            >
              {data.currency.map((v, i) => (
                <CustomOptionRefresh key={v.slice(0, 3)} value={v.slice(0, 3)}>
                  {v}
                </CustomOptionRefresh>
              ))}
            </CustomSelectRefresh>
          </div>
        </div>
        <div className="flex flex-col gap-5">
          <h5 className="text-onmoText text-2xl 4xl:text-3xl font-medium">
            Rates and overseas fees:
          </h5>
          <div className="border-0 rounded-xl bg-onmoPurple-50 border-onmoText grid gap-10 w-full place-self-center px-4 py-5 lg:px-[118px] lg:py-14 sm:grid-cols-2 grid-cols-1">
            <div className="flex flex-col gap-2.5 4xl:text-xl">
              <p className="text-base font-medium 4xl:text-xl">
                European Central Bank rate
              </p>
              <p className={"text-onmoText font-normal text-2xl"}>
                1 GBP ={" "}
                {loading ? (
                  <CircularProgress
                    thickness={6}
                    size={15}
                    className="text-onmoText"
                  />
                ) : (
                  `${rate.rateCompareResult.ecbRate} ${currency}`
                )}
              </p>
              <p className="text-onmoGrey-medium text-sm 4xl:text-lg">
                Date updated:{" "}
                {loading ? (
                  <CircularProgress
                    thickness={6}
                    size={15}
                    className="text-onmoGrey-medium ml-5"
                  />
                ) : (
                  new Date(rate.rateCompareResult.rateDate).toLocaleDateString(
                    "en-GB",
                    dateOptions,
                  )
                )}
              </p>
            </div>
            <div className="flex flex-col gap-2.5">
              <p className=" text-base font-medium 4xl:text-xl">Visa rate</p>
              <p className={"text-onmoText font-normal text-2xl"}>
                1 GBP ={" "}
                {loading ? (
                  <CircularProgress
                    thickness={6}
                    size={15}
                    className="text-onmoText"
                  />
                ) : (
                  `${rate.rateCompareResult.schemeRate}  ${currency}`
                )}
              </p>
              <p className="text-onmoGrey-medium text-sm 4xl:text-lg">
                Date updated:{" "}
                {loading ? (
                  <CircularProgress
                    thickness={6}
                    size={15}
                    className="text-onmoGrey-medium text-sm"
                  />
                ) : (
                  new Date(rate.rateCompareResult.rateDate).toLocaleDateString(
                    "en-GB",
                    dateOptions,
                  )
                )}
              </p>
            </div>
            <div className="flex flex-col gap-2.5">
              <p className="text-base font-medium 4xl:text-xl">
                Total mark-up over European Central Bank rate
              </p>
              <p className="text-onmoText font-normal text-2xl">
                {loading ? (
                  <CircularProgress
                    thickness={6}
                    size={15}
                    className="text-onmoText"
                  />
                ) : (
                  `${rate.rateCompareResult.partnerMarkupOverEcb}`
                )}
                %
              </p>
            </div>
            <div className="flex flex-col gap-2.5">
              <p className="text-base font-medium 4xl:text-xl">
                Onmo mark-up over Visa rate
              </p>
              <p className={"text-onmoText font-normal text-2xl"}>
                {loading ? (
                  <CircularProgress
                    thickness={6}
                    size={15}
                    className="text-onmoText"
                  />
                ) : (
                  `${rate.rateCompareResult.partnerFeePct}`
                )}
                %
              </p>
            </div>
          </div>
        </div>
        {/* using cutom style as we are giving styles to cms description */}
        <div className={styles.descriptionRefresh}>
          {description && <MDXRemote {...description} />}
        </div>
      </div>
    </>
  );
};

export default Fx;
